
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Calendar, LayoutGrid, CalendarDays } from 'lucide-react';
import WeeklyScheduleView from './views/WeeklyScheduleView';
import CalendarScheduleView from './views/CalendarScheduleView';
import MonthlyCalendarView from './views/MonthlyCalendarView';
import { ScheduleViewProps } from './types/scheduleTypes';

const ScheduleTabs: React.FC<ScheduleViewProps> = ({
  schedules,
  classes, // This now contains enhanced classes with schedules
  onScheduleUpdated,
  onScheduleDeleted,
  initialClassId
}) => {
  return (
    <Tabs defaultValue="weekly">
      <TabsList>
        <TabsTrigger value="weekly">
          <LayoutGrid className="h-4 w-4 mr-2" />
          Weekly Grid
        </TabsTrigger>
        <TabsTrigger value="calendar">
          <Calendar className="h-4 w-4 mr-2" />
          Calendar View
        </TabsTrigger>
        <TabsTrigger value="monthly">
          <CalendarDays className="h-4 w-4 mr-2" />
          Monthly View
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="weekly" className="pt-4">
        <WeeklyScheduleView 
          schedules={schedules}
          classes={classes}
          onScheduleUpdated={onScheduleUpdated}
          onScheduleDeleted={onScheduleDeleted}
          initialClassId={initialClassId}
        />
      </TabsContent>
      
      <TabsContent value="calendar" className="pt-4">
        <CalendarScheduleView
          schedules={schedules}
          classes={classes}
          onScheduleUpdated={onScheduleUpdated}
          onScheduleDeleted={onScheduleDeleted}
          initialClassId={initialClassId}
        />
      </TabsContent>
      
      <TabsContent value="monthly" className="pt-4">
        <MonthlyCalendarView
          schedules={schedules}
          classes={classes}
          onScheduleUpdated={onScheduleUpdated}
          onScheduleDeleted={onScheduleDeleted}
          initialClassId={initialClassId}
        />
      </TabsContent>
    </Tabs>
  );
};

export default ScheduleTabs;
